import React from 'react';
import { useTheme } from '../../theme/ThemeContext';
import Button from './button';

// const NeighborSelector = ({ value, onChange, onSelect, stepSize = 100, maxValue = 1000 }) => {
const NeighborSelector = ({ value, onChange, onSelect, stepSize = 1, maxValue = 1000 }) => {
    const { theme } = useTheme();

    const handleInputChange = (e) => {
        const newValue = parseInt(e.target.value, 10);
        if (!isNaN(newValue)) {
            const clampedValue = Math.min(Math.max(newValue, stepSize), maxValue);
            onChange(clampedValue);
        }
    };

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '10px 0'
    };

    const buttonWrapperStyle = {
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    };

    const inputStyle = {
        appearance: 'auto',
        border: 'none',
        borderRadius: '8px',
        // backgroundColor: theme.colors.background || 'rgba(255, 255, 255, 0.1)',
        backgroundColor: theme.colors.overlay || 'rgba(255, 255, 255, 0.1)',
        color: theme.colors.text,
        fontFamily: 'Arial',
        fontSize: '16px',
        fontWeight: '600',
        textAlign: 'center',
        padding: '4px 8px',
        width: '100px',
        minHeight: '32px',
        outline: 'none',
        margin: '0 10px',
        transition: 'all 300ms cubic-bezier(.23, 1, 0.32, 1)',
    };

    const buttonContentStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: '0 10px',
        gap: '8px'
    };

    return (
        <div style={containerStyle}>
            <div style={buttonWrapperStyle}>
                <Button onClick={() => onSelect(value)}>
                    <div style={buttonContentStyle}>
                        <span>add</span>
                        <input
                            type="number"
                            value={value}
                            onChange={handleInputChange}
                            min={stepSize}
                            max={maxValue}
                            step={stepSize}
                            style={inputStyle}
                            onClick={(e) => e.stopPropagation()} // Prevent button click when clicking input
                        />
                        <span>nearest neighbors</span>
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default NeighborSelector;